export enum Price_Type {
    open = 'OPEN',
    soom = 'ON-SOOM',
    normal = 'NORMAL',
    startsFrom = 'STARTED',
}